(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7726],{

/***/ 60216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ AnimateCarouselImage; },
/* harmony export */   "bv": function() { return /* binding */ AnimateIn; },
/* harmony export */   "ds": function() { return /* binding */ AnimateBugLeft; },
/* harmony export */   "kg": function() { return /* binding */ AnimateFeatureHeroRight; },
/* harmony export */   "lp": function() { return /* binding */ AnimateFeatureHeroXL; },
/* harmony export */   "nw": function() { return /* binding */ AnimateBugRight; }
/* harmony export */ });
/* unused harmony export AnimateMobileCarouselImage */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67285);



const AnimateIn = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: {
            bottom: -200
        },
        animate: {
            bottom: -38
        },
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "fixed",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2000
        },
        children: children
    });
};
const AnimateBugLeft = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        left: -300,
        top: 0,
        opacity: 0
    };
    const final = {
        left: -120,
        top: 125,
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "absolute",
            width: 250
        },
        children: children
    });
};
const AnimateBugRight = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        right: -275,
        top: -95,
        opacity: 0
    };
    const final = {
        right: -95,
        top: 30,
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "absolute",
            width: 250
        },
        children: children
    });
};
const AnimateCarouselImage = (param)=>{
    let { loaded , children , delay  } = param;
    const orig = {
        bottom: -300,
        opacity: 0
    };
    const final = {
        bottom: -20,
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4,
            delay: delay || 0
        },
        className: "absolute border-2 right-0 sm:w-[280px] md:w-[300px] lg:w-[450px] xl:w-[450px]",
        children: children
    });
};
const AnimateFeatureHeroRight = (param)=>{
    let { loaded , children , delay  } = param;
    const orig = {
        right: "-500px",
        opacity: 0
    };
    const final = {
        right: "-30px",
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4,
            delay: delay || 0
        },
        className: "absolute lg:-translate-y-96 xl:-translate-y-16 lg:w-[550px] xl:w-[650px] 2xl:w-[700px] ultra:w-[500px]",
        children: children
    });
};
const AnimateFeatureHeroXL = (param)=>{
    let { loaded , children , delay  } = param;
    const orig = {
        right: "-500px",
        opacity: 0
    };
    const final = {
        right: "0px",
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4,
            delay: delay || 0
        },
        className: "absolute ultra:w-[650px] translate-x-24 translate-y-8 h-full flex flex-col justify-center",
        children: children
    });
};
const AnimateMobileCarouselImage = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        bottom: -300,
        opacity: 0
    };
    const final = {
        bottom: 30,
        opacity: 1
    };
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4
        },
        className: "absolute bottom-0 border-2 border-red-500 h-[200px] w-[200px]",
        children: children
    });
};


/***/ }),

/***/ 70358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useMediaQuery = (width)=>{
    const [targetReached, setTargetReached] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const updateTarget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (e.matches) {
            setTargetReached(true);
        } else {
            setTargetReached(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const media = window.matchMedia("(max-width: ".concat(width, "px)"));
        media.addEventListener("change", (e)=>updateTarget(e));
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) {
            setTargetReached(true);
        }
        return ()=>media.removeEventListener("change", (e)=>updateTarget(e));
    }, [
        width,
        updateTarget
    ]);
    return targetReached;
};


/***/ }),

/***/ 29204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46466);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const PrimaryButton = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        ...props,
        onClick: (e)=>{
            var ref;
            if (window.dataLayer && ((ref = props.href) === null || ref === void 0 ? void 0 : ref.includes("app.highlight.io/sign_up"))) {
                e.preventDefault();
                if (props.onClick) {
                    props.onClick(e);
                }
                window.gtag("event", "conversion", {
                    send_to: "AW-10833687189/_C5MCLfmoY0YEJXl860o",
                    event_callback: function() {
                        if (props.href) {
                            window.location = props.href;
                        }
                    }
                });
                return false;
            } else {
                if (props.onClick) {
                    props.onClick(e);
                }
            }
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default().genericButton), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default().primaryButton)),
        children: children
    });
};


/***/ }),

/***/ 44688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ HighlightLogo; },
  "s": function() { return /* binding */ HighlightLogoWhite; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/logo-and-text-on-dark.svg
/* harmony default export */ var logo_and_text_on_dark = ({"src":"/_next/static/media/logo-and-text-on-dark.86efd8f2.svg","height":33,"width":167});
;// CONCATENATED MODULE: ./public/images/logo-and-text-on-purple.svg
/* harmony default export */ var logo_and_text_on_purple = ({"src":"/_next/static/media/logo-and-text-on-purple.0665af5c.svg","height":33,"width":167});
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.module.scss
var HighlightLogo_module = __webpack_require__(44579);
var HighlightLogo_module_default = /*#__PURE__*/__webpack_require__.n(HighlightLogo_module);
;// CONCATENATED MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx





const HighlightLogo = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightLogo_module_default()).logoDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: logo_and_text_on_dark,
            alt: ""
        })
    });
};
const HighlightLogoWhite = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightLogo_module_default()).logoDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: logo_and_text_on_purple,
            alt: ""
        })
    });
};


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@docsearch/react/dist/esm/DocSearch.js + 65 modules
var DocSearch = __webpack_require__(61627);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-github-btn/index.js
var react_github_btn = __webpack_require__(62719);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 191 modules
var motion = __webpack_require__(67285);
;// CONCATENATED MODULE: ./public/images/CrossIcon.tsx


function CrossIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: "#72E4FC"
        })
    });
}
/* harmony default export */ var images_CrossIcon = (CrossIcon);

// EXTERNAL MODULE: ./components/MediaQuery/MediaQuery.tsx
var MediaQuery = __webpack_require__(70358);
// EXTERNAL MODULE: ./components/GithubPopup/GithubPopup.module.scss
var GithubPopup_module = __webpack_require__(38921);
var GithubPopup_module_default = /*#__PURE__*/__webpack_require__.n(GithubPopup_module);
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
;// CONCATENATED MODULE: ./components/GithubPopup/GithubPopup.tsx








const GithubPopup = ()=>{
    const is400 = (0,MediaQuery/* useMediaQuery */.a)(400);
    const [lastPageLoadTime, setLastPageLoadTime] = (0,react.useState)(undefined);
    const key = "lastPageLoadTime";
    (0,react.useEffect)(()=>{
        var ref;
        const lplt = JSON.parse((ref = localStorage.getItem(key)) !== null && ref !== void 0 ? ref : "null");
        if (lplt) {
            setLastPageLoadTime(lplt);
        }
    }, [
        setLastPageLoadTime
    ]);
    (0,react.useEffect)(()=>{
        let timer = setTimeout(()=>{
            localStorage.setItem(key, JSON.stringify(new Date().getTime()));
        }, 1000);
        return ()=>{
            clearTimeout(timer);
        };
    });
    const popup = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: is400 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileGithubPopup, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopGithubPopup, {})
    });
    const delta = lastPageLoadTime && new Date().getTime() - lastPageLoadTime;
    // don't render if a render happened 60 seconds ago.
    return delta == undefined || delta && delta > 60 * 1000 ? popup : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
const MobileGithubPopup = ()=>{
    const [hide, setHide] = (0,react.useState)(false);
    return hide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateIn */.bv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GithubPopup_module_default()).mobilePopup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        fontSize: 18,
                        fontWeight: "400",
                        color: "white",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    children: "Star us on GitHub"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_github_btn/* default */.Z, {
                        href: "https://github.com/highlight/highlight",
                        "data-color-scheme": "no-preference: light; light: light; dark: light;",
                        "data-size": "large",
                        "data-show-count": "true",
                        "aria-label": "Star highlight/highlight on GitHub",
                        children: "Star"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>setHide(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_CrossIcon, {})
                })
            ]
        })
    });
};
const DesktopGithubPopup = ()=>{
    const [hide, setHide] = (0,react.useState)(false);
    return hide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        initial: {
            bottom: -200
        },
        animate: {
            bottom: 10
        },
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "fixed",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2000
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GithubPopup_module_default()).desktopPopup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        fontSize: 18,
                        fontWeight: "400",
                        color: "white",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    children: "Star us on GitHub"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_github_btn/* default */.Z, {
                        href: "https://github.com/highlight/highlight",
                        "data-color-scheme": "no-preference: light; light: light; dark: light;",
                        "data-size": "large",
                        "data-show-count": "true",
                        "aria-label": "Star highlight/highlight on GitHub",
                        children: "Star"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>setHide(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_CrossIcon, {})
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx + 2 modules
var HighlightLogo = __webpack_require__(44688);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(36109);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 4 modules
var popover = __webpack_require__(61761);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./components/common/Navbar/ResourceDropdown.module.scss
var ResourceDropdown_module = __webpack_require__(18419);
var ResourceDropdown_module_default = /*#__PURE__*/__webpack_require__.n(ResourceDropdown_module);
;// CONCATENATED MODULE: ./components/common/Navbar/ResourceDropdown.tsx









const ResourceDropdown = (param)=>{
    let { isOpen  } = param;
    const [isShowing, setIsShowing] = (0,react.useState)(false);
    const otherLinks = [
        {
            title: "Status Page",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiCloud */.aOQ, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://highlight.hyperping.io/"
        },
        {
            title: "Community",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiUsers */.AYC, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://discord.gg/yxaXEAqgwN"
        },
        {
            title: "Changelog",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiClipboardList */.sQ2, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://www.highlight.io/docs/general/changelog/overview"
        },
        {
            title: "Feedback",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiChat */.wIw, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://feedback.highlight.run"
        },
        {
            title: "Github",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillGithub */.RrF, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://github.com/highlight/highlight"
        },
        {
            title: "Blog",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiCollection */.CAn, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/blog",
            sameTab: true
        },
        {
            title: "Documentation",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiDocumentSearch */.m3O, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/docs",
            sameTab: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                        onMouseEnter: ()=>setIsShowing(true),
                        onMouseLeave: ()=>setIsShowing(false),
                        className: (ResourceDropdown_module_default()).popoverButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((ResourceDropdown_module_default()).headerButton, {
                                [(ResourceDropdown_module_default()).white]: isShowing
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[6.5px] items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy2",
                                        children: "Resources"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaChevronDown */.RiI, {
                                        className: "w-[10px]"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: isShowing,
                        onMouseEnter: ()=>setIsShowing(true),
                        onMouseLeave: ()=>setIsShowing(false),
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-1",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-1",
                        children: !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                            className: (ResourceDropdown_module_default()).popover,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ResourceDropdown_module_default()).popoverPanel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ResourceDropdown_module_default()).gridContainer,
                                    children: otherLinks.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: item.link,
                                            target: item.sameTab ? "" : "_blank",
                                            rel: "noreferrer",
                                            className: (ResourceDropdown_module_default()).gridItem,
                                            children: [
                                                item.icon,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    children: item.title
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Navbar_ResourceDropdown = (ResourceDropdown);

// EXTERNAL MODULE: ./node_modules/@docsearch/css/dist/style.css
var style = __webpack_require__(26428);
;// CONCATENATED MODULE: ./components/common/Navbar/FeatureDropdown.tsx








const FeatureDropdown = (param)=>{
    let { isOpen  } = param;
    const [isShowing, setIsShowing] = (0,react.useState)(false);
    const otherLinks = [
        {
            title: "Session Replay",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiFilm */.LhU, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/session-replay",
            sameTab: true
        },
        {
            title: "Error Monitoring",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiTerminal */.Zbf, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/error-monitoring",
            sameTab: true
        },
        {
            title: "Logging",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiLightningBolt */.NNQ, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/logging",
            sameTab: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                        onMouseEnter: ()=>setIsShowing(true),
                        onMouseLeave: ()=>setIsShowing(false),
                        className: (ResourceDropdown_module_default()).popoverButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((ResourceDropdown_module_default()).headerButton, {
                                [(ResourceDropdown_module_default()).white]: isShowing
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[6.5px] items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy2",
                                        children: "Product"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaChevronDown */.RiI, {
                                        className: "w-[10px]"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: isShowing,
                        onMouseEnter: ()=>setIsShowing(true),
                        onMouseLeave: ()=>setIsShowing(false),
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-1",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-1",
                        children: !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                            className: (ResourceDropdown_module_default()).popover,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ResourceDropdown_module_default()).popoverPanel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ResourceDropdown_module_default()).featureGridContainer,
                                    children: otherLinks.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: item.link,
                                            target: item.sameTab ? "" : "_blank",
                                            rel: "noreferrer",
                                            className: (ResourceDropdown_module_default()).gridItem,
                                            children: [
                                                item.icon,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    children: item.title
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Navbar_FeatureDropdown = (FeatureDropdown);

;// CONCATENATED MODULE: ./components/common/Navbar/Navbar.tsx















const Navbar = (param)=>{
    let { hideFreeTrialText , isDocsPage , hideBanner , fixed , title  } = param;
    const [scrolled, setScrolled] = (0,react.useState)(false);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [prevY, setPrevY] = (0,react.useState)(0);
    const changeBackground = ()=>{
        const currentScrollPos = window.pageYOffset;
        if (window.scrollY > 60 && prevY < currentScrollPos) {
            setScrolled(true);
        } else if (window.scrollY > 60 && prevY > currentScrollPos) {
            setScrolled(false);
        }
        setPrevY(currentScrollPos);
    };
    (0,react.useEffect)(()=>{
        changeBackground();
        window.addEventListener("scroll", changeBackground);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GithubPopup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Navbar_module_default()).container, {
                    [(Navbar_module_default()).hide]: scrolled && !fixed,
                    [(Navbar_module_default()).fixed]: fixed
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: classnames_default()({
                        [(Navbar_module_default()).mobileHeader]: isOpen
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Navbar_module_default()).header, (Navbar_module_default()).headerInner, {
                            [(Navbar_module_default()).openHeader]: isOpen,
                            [(Navbar_module_default()).headerBorder]: prevY != 0
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).headerLeft),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        className: (Navbar_module_default()).urlStyle,
                                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogoWhite */.s, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: classnames_default()((Navbar_module_default()).navTitle, {
                                                [(Navbar_module_default()).copyOnDark]: isOpen,
                                                [(Navbar_module_default()).copyOnLight]: !isOpen
                                            }),
                                            children: title
                                        })
                                    }),
                                    isDocsPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocSearch/* DocSearch */.F, {
                                        placeholder: "Search the highlight.io docs",
                                        appId: "JGT9LI80J2",
                                        indexName: "highlight",
                                        apiKey: "ac336720d8f4f996abe3adee603a1c84"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Navbar_module_default()).navMenu,
                                onClick: ()=>setIsOpen(!isOpen),
                                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                    className: (Navbar_module_default()).copyOnDark
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMenu */.qTj, {})
                            }),
                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Navbar_module_default()).mobileMenu,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: classnames_default()((Navbar_module_default()).menuList, (Navbar_module_default()).header),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/pricing",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Pricing"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/blog",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Blog"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://careers.highlight.run",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Careers"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/docs",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Docs"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Navbar_module_default()).menuButtons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                href: "https://app.highlight.io/sign_up",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                emphasis: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://app.highlight.io/",
                                                    className: (Navbar_module_default()).menuItem,
                                                    children: "Sign In"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isDocsPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).header, (Navbar_module_default()).headerCenter),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_FeatureDropdown, {
                                        isOpen: scrolled && !fixed
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pricing",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Pricing"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Blog"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_ResourceDropdown, {
                                        isOpen: scrolled && !fixed
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).header, (Navbar_module_default()).headerRight),
                                children: [
                                    !isDocsPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/docs",
                                        className: classnames_default()((Navbar_module_default()).headerButton, (Navbar_module_default()).headerButtonRight),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Docs"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://app.highlight.io/",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Sign in"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                        href: "https://app.highlight.io/sign_up",
                                        className: (Navbar_module_default()).signUpButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            emphasis: true,
                                            children: "Sign up"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Navbar_module_default()).socialButtonContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://github.com/highlight/highlight",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: classnames_default()((Navbar_module_default()).socialButtonWrapper, (Navbar_module_default()).socialButtonWrapperLeft),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillGithub */.RrF, {
                                                    className: classnames_default()((Navbar_module_default()).socialButton)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Navbar_module_default()).socialButtonDivider
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://discord.gg/yxaXEAqgwN",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: classnames_default()((Navbar_module_default()).socialButtonWrapper, (Navbar_module_default()).socialButtonWrapperRight),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaDiscord */.j2d, {
                                                    className: classnames_default()((Navbar_module_default()).socialButton)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);


/***/ }),

/***/ 20026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46717);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Typography = (param)=>{
    let { children , emphasis =false , onDark =false , className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, {
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copyHeader)]: props.type === "copyHeader",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy1)]: props.type === "copy1",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy2)]: props.type === "copy2",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy3)]: props.type === "copy3",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy4)]: props.type === "copy4",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().outline)]: props.type === "outline",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().emphasis)]: emphasis,
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().onDark)]: onDark
        }),
        children: children
    });
};


/***/ }),

/***/ 38921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobilePopup":"GithubPopup_mobilePopup__FKeVw","desktopPopup":"GithubPopup_desktopPopup__yFGtn"};

/***/ }),

/***/ 19350:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgPosition":"Home_bgPosition__wAgzT","purpleDiv":"Home_purpleDiv__U1nYG","blueDiv":"Home_blueDiv__5yHEw","highlightedText":"Home_highlightedText__8FhfX","mobileOnly":"Home_mobileOnly__aBfw6","hideImage":"Home_hideImage__Plyay","hero":"Home_hero___9_fZ","bigHero":"Home_bigHero__mHvsY","heroVideoWrapper":"Home_heroVideoWrapper__EHYd2","heroBug":"Home_heroBug__0zF_Z","footerImageLeft":"Home_footerImageLeft__WsciO","footerImageRight":"Home_footerImageRight__XpAKQ","search":"Home_search__cFkvx","searchTwoHighlighters":"Home_searchTwoHighlighters__ogBBt","obfuscation":"Home_obfuscation__wu3rO","obfuscationImage":"Home_obfuscationImage__piAA3","obfuscationHandle":"Home_obfuscationHandle__lK2O8","arrow1":"Home_arrow1__b8JhO","arrow2":"Home_arrow2__VX9LF","secondaryBackground":"Home_secondaryBackground__Zx2wQ","bodyLarge":"Home_bodyLarge__tSI5E","bodySmall":"Home_bodySmall__EXSbN","gradientText":"Home_gradientText__IArQU","carouselButton":"Home_carouselButton__P59J_","carouselContainer":"Home_carouselContainer__Ch0IB","innerCarouselFeature":"Home_innerCarouselFeature__Eeegy","innerCarouselButton":"Home_innerCarouselButton__5M3Pe","featuresColumnContainer":"Home_featuresColumnContainer__pStUx","featuresSection":"Home_featuresSection__l9CPb","featuresLeftColumn":"Home_featuresLeftColumn__9D9at","featuresRightColumn":"Home_featuresRightColumn__jteoH","sectionText":"Home_sectionText__wDy47","codeSection":"Home_codeSection__VT9qe","sectionSubtitle":"Home_sectionSubtitle__4rtrm","heroImage":"Home_heroImage__WKvpt","sectionCollapse":"Home_sectionCollapse__X6LN3","collapseHeader":"Home_collapseHeader__uElNF","sectionBody":"Home_sectionBody__mCAeO","sectionInfo":"Home_sectionInfo__2iFG2","sectionImageRight":"Home_sectionImageRight__1xodv","sectionImageLeft":"Home_sectionImageLeft__ETiIR","gridSectionImageLeft":"Home_gridSectionImageLeft__23JPF","imageInner":"Home_imageInner__dGWRZ","buttonContainer":"Home_buttonContainer__EQoF4","anchorTitle":"Home_anchorTitle__nlk3B","anchorFeature":"Home_anchorFeature___BCJT","secondaryAnchor":"Home_secondaryAnchor__ZBaJx","anchorHead":"Home_anchorHead__VFK66","landingAnchorHead":"Home_landingAnchorHead__yx61Q","hideVideo":"Home_hideVideo__6MnYf","modalBg":"Home_modalBg__687XX","modalClose":"Home_modalClose__EaHCX","videoModal":"Home_videoModal__H3dO2","anchorImage":"Home_anchorImage__VpZv6","thumbnail":"Home_thumbnail__4ICK8","playButton":"Home_playButton__S6Kth","playButtonIcon":"Home_playButtonIcon__3XStT","jayImage":"Home_jayImage__wCQ8Q","playCard":"Home_playCard__Pz3Ti","reviewCard":"Home_reviewCard__UrEJs","reviewText":"Home_reviewText__D98qS","author":"Home_author__lDCTd","authorImage":"Home_authorImage__TCSy0","companyLogo":"Home_companyLogo__zDXHQ","slider":"Home_slider__U9_UX","slideTrack":"Home_slideTrack__YI_Es","featureContainer":"Home_featureContainer__w9_U6","featureItem":"Home_featureItem__P5rMf","snippetTabs":"Home_snippetTabs__gGjHj","snippetTab":"Home_snippetTab__VDY3N","tabSelected":"Home_tabSelected__XI_us","snippetBeta":"Home_snippetBeta__HLkL5","codeSnippetFrame":"Home_codeSnippetFrame__cbeSD","codeSnippetTopbar":"Home_codeSnippetTopbar__hMBYe","codeSnippetButtons":"Home_codeSnippetButtons___6sSK","codeSnippetIcon":"Home_codeSnippetIcon__TWl9b","codeSnippetCircle":"Home_codeSnippetCircle__4DcAU","codeSnippetContent":"Home_codeSnippetContent__ijs7O","codeSnippetCopy":"Home_codeSnippetCopy__D2JjV","codeSnippetCopyIcon":"Home_codeSnippetCopyIcon__5c2fr","snippetContent":"Home_snippetContent__8vJ0S","simpleCallToActionBackground":"Home_simpleCallToActionBackground__3_HIR","ctaContainer":"Home_ctaContainer__b0AdQ","callToActionBackground":"Home_callToActionBackground__6oa7a","ctaTitle":"Home_ctaTitle__b9XOq","ctaBg":"Home_ctaBg__rJNt3","anchorSmall":"Home_anchorSmall__9aaME","tryButtonContainer":"Home_tryButtonContainer__Hg9Z2","ossCard":"Home_ossCard__TvoFX","hollowButton":"Home_hollowButton__xgjkW","solidButton":"Home_solidButton__KDQjm","whiteButton":"Home_whiteButton__wj4ES","customerReel":"Home_customerReel__IyG_E","infoContainer":"Home_infoContainer__ZN8Ov","landingInfoRow":"Home_landingInfoRow__x3lbc","companies":"Home_companies__hnoH0","scaleHeight":"Home_scaleHeight__sk2mZ","customerCopy":"Home_customerCopy__TFmmF","buttonArrow":"Home_buttonArrow__X5__0","arrow":"Home_arrow__wJ3BP","hideMobile":"Home_hideMobile__km2kc","hidePhone":"Home_hidePhone__P85fL","mobile":"Home_mobile__7C5FA","tabletGraphic":"Home_tabletGraphic__fpYA0","snippetDropdownContainer":"Home_snippetDropdownContainer__og6TK","snippetDropdown":"Home_snippetDropdown__Drnq0","snippetDropdownValue":"Home_snippetDropdownValue__zs1LC","snippetDropdownList":"Home_snippetDropdownList__xZURP","collaborationGraphic":"Home_collaborationGraphic__Fju9A","heroBugLeft":"Home_heroBugLeft__SONAZ","heroBugRight":"Home_heroBugRight__dcnHU","mobileSpacing":"Home_mobileSpacing__fhaMr","scroll":"Home_scroll__csog8"};

/***/ }),

/***/ 46466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"Buttons_genericButton__1FVcd","primaryButton":"Buttons_primaryButton__F0qwS","secondaryButton":"Buttons_secondaryButton__ONMAh","arrow":"Buttons_arrow__FYbFj"};

/***/ }),

/***/ 44579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"HighlightLogo_logoDiv__7LoQB","logoText":"HighlightLogo_logoText__yxbvU","logo":"HighlightLogo_logo__bx_mM"};

/***/ }),

/***/ 36109:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__Hki0p","hide":"Navbar_hide__zNudc","header":"Navbar_header__4yLzB","headerPadding":"Navbar_headerPadding__I31dq","headerInner":"Navbar_headerInner__WU6T_","headerBorder":"Navbar_headerBorder__vq_i7","hideNavbar":"Navbar_hideNavbar__aZu63","navContainer":"Navbar_navContainer__Pkz7d","navMenu":"Navbar_navMenu__vSmJQ","mobileMenu":"Navbar_mobileMenu__lUigM","menuList":"Navbar_menuList__bWJqX","menuItem":"Navbar_menuItem__q_j2E","chevronDown":"Navbar_chevronDown__L4333","menuDropdown":"Navbar_menuDropdown__oDsSP","headerButton":"Navbar_headerButton__zJw2r","headerButtonRight":"Navbar_headerButtonRight__s4Uep","popoverButton":"Navbar_popoverButton__WiIZs","popover":"Navbar_popover__VpYiX","popoverPanel":"Navbar_popoverPanel___S3Zu","innerPopoverPanel":"Navbar_innerPopoverPanel__IVRN3","copyOnLight":"Navbar_copyOnLight__hCG9U","copyOnDark":"Navbar_copyOnDark__o_J8Z","white":"Navbar_white__e_2Nx","gridContainer":"Navbar_gridContainer__G_6Aq","innerGridContainer":"Navbar_innerGridContainer__3rIoQ","gridItem":"Navbar_gridItem__OAdnU","signUpButton":"Navbar_signUpButton__p_R_j","headerLeft":"Navbar_headerLeft__pZY9_","headerLeftBlog":"Navbar_headerLeftBlog__mTNOx","headerCenter":"Navbar_headerCenter__flPxm","headerRight":"Navbar_headerRight__IvOsm","socialButtonContainer":"Navbar_socialButtonContainer__5c9GH","socialButtonWrapper":"Navbar_socialButtonWrapper__xU9QK","socialButton":"Navbar_socialButton__UeEDd","socialButtonWrapperLeft":"Navbar_socialButtonWrapperLeft__mYCJz","socialButtonWrapperRight":"Navbar_socialButtonWrapperRight__TlP3q","socialButtonDivider":"Navbar_socialButtonDivider__bzsqw","urlStyle":"Navbar_urlStyle__VOVlz","dropdownItem":"Navbar_dropdownItem__Y_43b","bannerContainer":"Navbar_bannerContainer__NWyOW","callToAction":"Navbar_callToAction__v1q4L","bannerContainerBlog":"Navbar_bannerContainerBlog__a6fvz","navTitle":"Navbar_navTitle__pjZ9_","navPostTitle":"Navbar_navPostTitle__O2TUd","loadingBar":"Navbar_loadingBar__BZ3Iq","fixed":"Navbar_fixed__NYJVb","openHeader":"Navbar_openHeader__pxQwC","mobileHeader":"Navbar_mobileHeader__rk96w","menuButtons":"Navbar_menuButtons__8kzLj","menuItemLarge":"Navbar_menuItemLarge__B4JsK"};

/***/ }),

/***/ 18419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerButton":"ResourceDropdown_headerButton__mjZ65","popoverButton":"ResourceDropdown_popoverButton__obeHV","popover":"ResourceDropdown_popover__ZWDlP","popoverPanel":"ResourceDropdown_popoverPanel__1BfEb","copyOnLight":"ResourceDropdown_copyOnLight__mABGq","copyOnDark":"ResourceDropdown_copyOnDark__Bm6cX","white":"ResourceDropdown_white__chyYq","gridContainer":"ResourceDropdown_gridContainer__RApN7","featureGridContainer":"ResourceDropdown_featureGridContainer__XjRFx","gridItem":"ResourceDropdown_gridItem__R4CG6"};

/***/ }),

/***/ 46717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"copyHeader":"Typography_copyHeader__vgPrK","copy1":"Typography_copy1__Cenb_","copy2":"Typography_copy2__ebmOc","copy3":"Typography_copy3__66v_e","copy4":"Typography_copy4__R2A2_","onDark":"Typography_onDark__0klmC","emphasis":"Typography_emphasis__GjrIs","outline":"Typography_outline__J0c64"};

/***/ })

}]);